<script setup>
import { computed, ref, onMounted } from 'vue'
import { getRandomTestimonials } from '~/data/testimonials'

const props = defineProps({
  title: {
    type: String,
    default: 'Was unsere Kunden über uns sagen'
  },
  subtitle: {
    type: String,
    default: 'Erfahrungen unserer zufriedenen Kunden.'
  },
  locationName: {
    type: String,
    default: ''
  }
})

const randomTestimonials = ref([])

onMounted(() => {
  randomTestimonials.value = getRandomTestimonials(3)
})

const displayTitle = computed(() => {
  if (props.locationName) {
    return `Was unsere Kunden über uns sagen`
  }
  return props.title
})
</script>

<template>
  <section class="py-16 bg-gray-50">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h2 class="heading-2 mb-4">{{ displayTitle }}</h2>
        <p class="text-lg text-gray-600 max-w-3xl mx-auto">{{ subtitle }}</p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div v-for="(testimonial, index) in randomTestimonials" :key="index" class="bg-white p-6 rounded-lg shadow">
          <div class="flex mb-2">
            <span v-for="i in testimonial.rating" :key="i" class="text-yellow-400">★</span>
          </div>
          <p class="text-gray-600 mb-4">"{{ testimonial.text }}"</p>
          <div>
            <p class="font-semibold">{{ testimonial.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>